import { Skeleton } from "antd"
import styled from "styled-components"

export const ProfileFormSkeleton = () => {
  return (
    <StyledFormWrapper>
      <StyledLabelSkeleton active
        size="small"
      />

      <StyledInputSkeleton active
        size="large"
      />

      <StyledLabelSkeleton active
        size="small"
      />

      <StyledInputSkeleton active
        size="large"
      />

      <StyledButtonSkeleton active
        size="large"
      />
    </StyledFormWrapper>
  )
}

const StyledFormWrapper = styled.div`
  display: flex;
  flex-flow: column;
  max-width: 480px;
  margin: 24px auto 0 0;
`

const StyledLabelSkeleton = styled(Skeleton.Input)`
  &&& {
    width: 40px;
    height: 24px;
    margin-bottom: 12px;
  }
`

const StyledInputSkeleton = styled(Skeleton.Input)`
  &&& {
    width: 100%;
    height: 32px;
    margin-bottom: 24px;
  }
`

const StyledButtonSkeleton = styled(Skeleton.Button)`
  &&& {
    width: 120px;
    height: 32px;
  }
` 